export const buildImagesParam = (imgData) => {
  const imgIds = [];
  imgData.forEach((value) => {
    if (value.image) {
      const lastSlashIndex = value.image.lastIndexOf('/');
      const imageId = value.image.substring(lastSlashIndex + 1);
      imgIds.push(imageId);
    }
  });
  return imgIds.join(',');
};

const buildMenuBodyChildren = ({ children }) => {
  children.forEach((child, index) => {
    delete children[index].indicatorImage;
    delete children[index].secondaryValue;
    delete children[index].placeholder;
    delete children[index].collapsed;
    delete children[index].isVisible;
    delete children[index].isRoot;

    if (child?.children?.length) {
      buildMenuBodyChildren({ children: child.children });
    }
    children[index] = { ...child, subject: child.subject.uri };
  });

  return children;
};

export const getBodyIrdMenu = ({ irdMenu }) => {
  const menuChildren = buildMenuBodyChildren({
    children: JSON.parse(JSON.stringify(irdMenu.menu.children)),
  });

  const menuBody = {
    active: irdMenu.menu.active,
    children: menuChildren,
    id: irdMenu.id,
    subject: irdMenu.menu.subject.uri,
    type: irdMenu.menu.type,
    valid_child_types: irdMenu.menu.valid_child_types,
    deeplink: irdMenu.menu.deeplink,
  };

  const bodyIrdMenu = {
    uri: irdMenu.uri,
    group: irdMenu.group,
    id: irdMenu.id,
    title: irdMenu.title,
    menu: menuBody,
  };
  return bodyIrdMenu;
};
